import {connect, MapStateToProps} from "react-redux";
import BackendErrorDialog, {Props} from "../components/BackendErrorDialog";
import {RootState} from "@/store";

const mapStateToProps: MapStateToProps<Props, Record<string, never>, RootState> = (store: RootState) => ({
    backendError: store.backendError,
});

export default connect(mapStateToProps)(BackendErrorDialog);
